export const FormDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type FormDirection = (typeof FormDirection)[keyof typeof FormDirection]

export const FormJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type FormJustifyContent =
  (typeof FormJustifyContent)[keyof typeof FormJustifyContent]

export const FormAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type FormAlignItems =
  (typeof FormAlignItems)[keyof typeof FormAlignItems]

export const FormWrap = {
  Nowrap: 'nowrap',
  Wrap: 'wrap',
  WrapReverse: 'wrap-reverse',
  Revert: 'revert',
} as const
export type FormWrap = (typeof FormWrap)[keyof typeof FormWrap]
